import React from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useIntl } from 'react-intl-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import LoadingButton from '@atlaskit/button/loading-button';
import { ANALYTICS_CHANNEL, LINK_CREATE_FORM_POST_CREATE_FIELD } from '../../../../common/constants';
import createEventPayload from '../../../../common/utils/analytics/analytics.codegen';
import { useFormContext } from '../../../../controllers/form-context';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { FormSpy } from '../../form-spy';
import { messages } from './messages';
export var EditButton = function EditButton() {
  var intl = useIntl();
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useFormState = useFormState(),
    submitting = _useFormState.submitting;
  var _useForm = useForm(),
    submit = _useForm.submit,
    mutators = _useForm.mutators;
  var _useFormContext = useFormContext(),
    enableEditView = _useFormContext.enableEditView;
  if (!enableEditView) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FormSpy, null, function (_ref) {
    var values = _ref.values;
    return /*#__PURE__*/React.createElement(LoadingButton, {
      type: "button",
      testId: "link-create-form-button-edit",
      isLoading:
      /**
       * Should only be in a loading state if submitting is because we clicked
       * the edit button
       */
      submitting && values[LINK_CREATE_FORM_POST_CREATE_FIELD] === true,
      onClick: function onClick() {
        var _mutators$setField;
        createAnalyticsEvent(createEventPayload('ui.button.clicked.edit', {})).fire(ANALYTICS_CHANNEL);
        /**
         * Setting this field to true indicates that the edit button was clicked and that
         * we have the intention of triggering the edit/post create flow
         */
        (_mutators$setField = mutators.setField) === null || _mutators$setField === void 0 || _mutators$setField.call(mutators, LINK_CREATE_FORM_POST_CREATE_FIELD, true);
        submit();
      }
    }, intl.formatMessage(messages.createAndOpen));
  });
};